import { Input } from '@storeblocks/input';
import { type FC, useState } from 'react';
import styled from 'styled-components';

import { Fund } from '@/api/funds/models';
import { WithGap } from '@/components/WithGap';
import { useTexts } from '@/hooks/useTexts';

import { FundListAccordion } from './FundListAccordion';
import { fuzzySearchFunds } from './utils/fuzzySearchFunds';

interface Props {
  funds: Fund[];
}

export const AllConnectFunds: FC<Props> = ({ funds }) => {
  const texts = useTexts();

  const [filter, setFilters] = useState<{
    result: Fund[];
    query: string;
  }>({
    result: funds,
    query: '',
  });

  const handleSearch = (query: string): void => {
    const filteredFunds = fuzzySearchFunds(query, funds);

    setFilters({
      result: filteredFunds,
      query: query,
    });
  };

  return (
    <WithGap>
      <h2>{texts.pages.fundList.allFunds.title}</h2>

      <Wrapper>
        <Input
          id="fund-list-search-input"
          name="fund-list-search-input"
          label={texts.pages.fundList.allFunds.search}
          value={filter.query}
          onChange={(e) => handleSearch(e.target.value)}
          icon={{ name: 'search' }}
          fluid
          autoComplete="off"
        />
      </Wrapper>
      <FundListAccordion
        funds={filter.result}
        data-test="fund-list-all-funds"
        hasHoldingsInFunds={false}
      />
    </WithGap>
  );
};

const Wrapper = styled.div`
  width: 528px;
`;
